<template>
  <!-- 轮播图 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header switch-box">
      <el-switch @change="ChangeVip" v-model="value1" active-text="重大事件">
      </el-switch>

      <span v-if="value1" class="m-btn" @click="showVip">编辑</span>
      <el-switch style="margin-left: 40px;" v-model="value2" @change="ChangeGray" active-text="网站灰度">
      </el-switch>
      <!-- <el-form class="com-search-box" :model="form" ref="form">
        <el-row>
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.name" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div> -->
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加轮播图
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="轮播名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="url" label="链接" show-overflow-tooltip>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="25%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">查看</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>

              <a class="mr-10" @click="upCarousel(scope.row)" v-if="scope.$index != 0"><i class="el-icon-top"></i></a>
              <a @click="downCarousel(scope.row)"
                v-if="((listQuery.currentPage-1)*listQuery.size + scope.$index +1) != total"><i
                  class="el-icon-bottom"></i></a>

            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog :title="operation == 'add' ? '新增轮播图': operation == 'edit' ? '编辑轮播图':'查看轮播图'" @close="onCancel"
        :visible.sync="dialogVisible" :width="'600px'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-form-item class="mb-30" prop="name">
            <el-input v-model="addForm.name" :disabled="operation == 'view'" placeholder="请输入轮播名称" />
          </el-form-item>

          <el-form-item class="mb-30" prop="url">
            <el-input v-model="addForm.url" :disabled="operation == 'view'" placeholder="请输入跳转链接" />
          </el-form-item>

          <el-form-item class="avatar-uploader-form" prop="picId">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'"
              accept=".jpg,.jpeg,.png,.JPG" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" style="height:120px;object-fit:contain;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传轮播图封面</div>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation != 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" :loading="loadingSave" @click="onSubmit()">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="重大事件设置" :visible.sync="dialogVisible1" :width="'600px'" @close="onCancel1">
        <el-form ref="vipForm" :model="vipForm" :rules="rules1">
          <el-form-item class="mb-30" prop="title">
            <el-input v-model="vipForm.title" :disabled="operation == 'view'" placeholder="事件名称" />
          </el-form-item>

          <el-form-item class="mb-30" prop="url">
            <el-input v-model="vipForm.url" :disabled="operation == 'view'" placeholder="超链接地址" />
          </el-form-item>

          <el-form-item class="avatar-uploader-form" prop="fileId">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'"
              accept=".jpg,.jpeg,.png,.JPG" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl1" style="width: 100%;height: 150px;object-fit:contain;" :src="imgUrl1" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">重大事件封面</div>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>

        <div class="dialog-footer tr mt-30">
          <el-button @click="onCancel1">取 消</el-button>
          <el-button type="primary" :loading="loadingSave" @click="onSubmit1()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  data() {
    const validateFile = (rule, value, callback) => {
      if (!this.addForm.picId) {
        callback(new Error('轮播图不能为空'))
      } else {
        callback()
      }
    }

    const validateFile1 = (rule, value, callback) => {
      if (!this.vipForm.fileId) {
        callback(new Error('事件图不能为空'))
      } else {
        callback()
      }
    }
    return {
      form: {
        name: '',
        type: '3'
      },
      vipObj: {},
      vipForm: {},
      value1: false,
      value2: false,
      loadingSave: false,
      operation: 'add',
      addForm: {},
      rules: {
        name: [{ required: true, message: '轮播图名称不能为空', trigger: 'blur' }],
        picId: [{ required: true, validator: validateFile, trigger: 'blur' }],
        fileId: [{ required: true, validator: validateFile1, trigger: 'blur' }],
      },

      rules1: {
        name: [{ required: true, message: '重大事件名称不能为空', trigger: 'blur' }],
      },
      configData: {
        tableName: 'collect'
      },
      imgUrl1: "",
      imgUrl: "",
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      dialogVisible1: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet.getCarouselList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    showVip() {
      this.dialogVisible1 = true
      this.getOpenInfo()
    },

    ChangeGray(val) {
      if (val) {
        this.openGray()
      } else {
        this.closeGray()
      }
    },

    ChangeVip(val) {
      if (val) {
        this.dialogVisible1 = true
        this.openVipInfo()
      } else {
        this.closeVipInfo()
      }
    },

    openGray() {
      this.$http.get('/webadmin/openGray').then(res => {
        if (res.success) {
          this.$message.success('打开网站灰度')
          this.getGray()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    closeGray() {
      this.$http.get('/webadmin/closeGray').then(res => {
        if (res.success) {
          this.$message.success('关闭网站灰度')
          this.getGray()
        } else {
          this.$message.error(res.message)
        }
      })
    },


    getOpenInfo() {
      this.$http.get('/webadmin/queryVipInfo').then(res => {
        if (res.success) {
          if (res.result) {
            this.vipForm = res.result || []
            this.vipObj = res.result || []
            this.imgUrl1 = res.result.imgUrl
            this.value1 = res.result.vip === '1' ? true : false
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    openVipInfo() {
      this.$http.get('/webadmin/openVipInfo').then(res => {
        if (res.success) {
          this.getOpenInfo()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    closeVipInfo() {
      this.$http.get('/webadmin/closeVipInfo').then(res => {
        if (res.success) {
          this.$message.success('关闭重大事件')
        } else {
          this.$message.error(res.message)
        }
      })
    },

    getGray() {
      this.$http.get('/webadmin/queryGray').then(res => {
        if (res.success) {
          this.value2 = res.result.gray === '1' ? true : false
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 重置查询
    resetForm() {
      this.form = {
        name: '',
        type: '1'
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleView(obj) {
      this.operation = "view"
      this.$api.applet.getCarouselDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
            if (res.result.picId) {
              this.imgUrl = res.result.picId
            }
          }
        }
      })
    },

    upCarousel(obj) {
      this.$api.applet.upCarousel({ id: obj.id, type: obj.type }).then(res => {
        if (res.success) {
          this.getData()
        }else{
          this.$message.error(res.message)
        }
      })
    },

    downCarousel(obj) {
      this.$api.applet.downCarousel({ id: obj.id, type: obj.type }).then(res => {
        if (res.success) {
          this.getData()
        }else{
          this.$message.error(res.message)
        }
      })
    },

    // 新增
    handleAdd(operator, id) {
      this.operation = "add"
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      if (obj.picId && obj.picId.indexOf('/singleMuseum/attach/getFile') == -1) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.picId}`
      } else {
        if (obj.picId) {
          this.addForm.picId = obj.picId.split('=')[1]
          this.imgUrl = obj.picId
        }
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.delCarousel({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        if (this.dialogVisible1) {
          this.imgUrl1 = res.result.attPath
          this.vipForm.fileId = res.result.attId
          if (this.vipForm.fileId) {
            this.$refs.vipForm.clearValidate('fileId');
          }
        } else {
          this.imgUrl = res.result.attPath
          this.addForm.picId = res.result.attId
          if (this.addForm.picId) {
            this.$refs.form.clearValidate('picId');
          }
        }
      } else {
        this.$message.error(res.message)
      }
    },

    onSubmit() {
      const self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          let url = "addCarousel"
          if (this.addForm.id) {
            url = "updateCarousel"
          }
          this.addForm.type = '3'
          this.$api.applet[url](this.addForm).then(res => {
            this.loadingSave = false
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '轮播图修改成功' : '新增轮播图成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getData()
                }
              })
            }
          }).catch(err => {
            this.loadingSave = false
          })
        } else {
          return false;
        }
      });
    },

    onSubmit1() {
      const self = this
      this.$refs["vipForm"].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          this.vipForm.vip = '1'
          this.$http.get('/webadmin/updateVipInfo', this.vipForm).then(res => {
            this.loadingSave = false
            if (res.success) {
              this.$message.success({
                message: res.message,
                duration: 500,
                onClose() {
                  // self.getOpenInfo()

                  self.onCancel1()
                }
              })
            }
          }).catch(err => {
            this.loadingSave = false
          })
        } else {
          return false;
        }
      });
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ""
      this.$refs["form"].clearValidate()
    },

    onCancel1() {
      this.dialogVisible1 = false
      this.vipForm = {}
      this.imgUrl1 = ""
      this.$refs["vipForm"].clearValidate()
    },


    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    },
  },
  created() {
    this.getData()
    this.getOpenInfo()
    this.getGray()
    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  .switch-box {
    display: flex;
    align-items: center;
    span {
      margin-left: 20px;
      text-decoration: underline;
    }
  }
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-upload {
          width: 100%;
        }
        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
    }
  }
}
</style>